module.exports = __webpack_public_path__ + "static/media/1014359.3952f8a2.jpg";